import React from 'react';
import {AppHeaderLogo,AppHeaderLogoImg,HeaderInner,HeaderNotShowed,HeaderShowed} from '../../styles/jss/components/header';
import {SocialList,SocialListItem,SocialListLink,SocialWrapper,HeaderSocialWrapper} from "../../styles/jss/global"
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from "@mui/icons-material/Instagram";
import {TikTokIcon} from "../../constants/tikTokLink";

interface HeaderProps {
  showHeader: boolean;
  showHeaderSocial?: boolean;
  app: {
    bgImage?: string;
    logo?: string;
    facebookLink?: string;
    twitterLink?: string;
    linkedinLink?: string;
    instagramLink?: string;
    tikTokLink?: string;
  };
}

const Header: React.FC<HeaderProps> = (props) => {
    const styles = {
        appBgImage: {
            backgroundImage: `url(${props.app.bgImage})`
        }
    };
    const Comp = props.showHeader ? HeaderShowed : HeaderNotShowed

    return (
        <Comp component="header">
            {props.showHeader &&
                <HeaderInner withBgImage={Boolean(props.app.bgImage)} maxWidth="lg" style={props.app.bgImage ? styles.appBgImage : undefined}>
                    {
                        props.app.logo &&
                            <AppHeaderLogo>
                                <AppHeaderLogoImg src={props.app.logo} alt="App logo" />
                            </AppHeaderLogo>
                    }

                    <SocialWrapper display={{ xs: 'block', md: `${props.showHeaderSocial ? 'block' : 'none'}`}}>
                        <HeaderSocialWrapper>
                            <SocialList>
                                {props.app.facebookLink &&
                                    <SocialListItem>
                                        <SocialListLink aria-label="Facebook" href={props.app.facebookLink} target="_blank" rel="noopener noreferrer"><FacebookOutlinedIcon /></SocialListLink>
                                    </SocialListItem>
                                }
                                {props.app.twitterLink &&
                                    <SocialListItem>
                                        <SocialListLink aria-label="X" href={props.app.twitterLink} target="_blank" rel="noopener noreferrer"><TwitterIcon /></SocialListLink>
                                    </SocialListItem>
                                }
                                {props.app.linkedinLink &&
                                    <SocialListItem>
                                        <SocialListLink aria-label="LinkedIn" href={props.app.linkedinLink} target="_blank" rel="noopener noreferrer"><LinkedInIcon /></SocialListLink>
                                    </SocialListItem>
                                }
                                {props.app.instagramLink &&
                                    <SocialListItem>
                                        <SocialListLink aria-label="Instagram" href={props.app.instagramLink} target="_blank" rel="noopener noreferrer"><InstagramIcon /></SocialListLink>
                                    </SocialListItem>
                                }
                                {props.app.tikTokLink &&
                                    <SocialListItem>
                                        <SocialListLink aria-label="TikTok" href={props.app.tikTokLink} target="_blank" rel="noopener noreferrer"><TikTokIcon /></SocialListLink>
                                    </SocialListItem>
                                }
                            </SocialList>
                        </HeaderSocialWrapper>
                    </SocialWrapper>
                       
                </HeaderInner>
            }
        </Comp>
    );
}

export default Header;
